module.exports = __webpack_public_path__ + "img/Patch22-2.eddb0d78.webp";